import Rails from "@rails/ujs"
import * as Turbo from "@hotwired/turbo-rails"
import jquery from "jquery"
import * as bootstrap from "bootstrap"

if (!window.Rails) {
  Rails.start()
  window.Rails = Rails
}

window.Turbo = Turbo
window.$ = jquery
window.jQuery = jquery
window.bootstrap = bootstrap

export { Turbo, Rails, bootstrap, jquery as $ }
